























































import Vue from 'vue';
import api from '@/common/api';
import {
  RateLimit, initRateLimit,
} from '@/common/components/support/support.types';
import PageLoader from '@/common/components/PageLoader.vue';
import LoadingModal from '@/common/components/LoadingModal.vue';

export default Vue.extend({
  data() {
    return {
      rateLimits: initRateLimit() as RateLimit,
      isSubmitting: false as boolean,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      api
        .get('/merchant/settings')
        .then(({ data }) => {
          if (typeof data.data.settings.rateLimits !== 'undefined') {
            this.rateLimits = data.data.settings.rateLimits!;
          }

          (this.$refs.loader as any).setReady();
        })
        .catch(() => {
          (this.$refs.loader as any).setReady();
        });
    },
    saveData() {
      this.isSubmitting = true;

      api
        .post('/merchant/settings', {
          rateLimits: this.rateLimits,
        })
        .then(() => {
          this.isSubmitting = false;
          this.$toasted.success('Rate Limits saved successfully!');
          (this.$refs.form as any).resetValidation();
        })
        .catch(({ response }) => {
          this.isSubmitting = false;
          let msg: any = '';
          if (response?.data?.errors) {
            const errors = response?.data?.errors;
            Object.keys(errors).forEach((key: any, idx: any) => {
              if (idx > 0) msg += '<br />';
              msg += `${errors[key]}`;
            });
          } else if (response?.data?.message) {
            msg += response?.data?.message;
          }
          if (msg) this.$toasted.error(msg);
        });
    },
  },
  components: {
    PageLoader,
    LoadingModal,
  },
});
